import React from 'react';

import { InnerWrapper } from '../styles';
import NavigationSteps from '../navigation-steps';
import type { StepHeaderNavigationProps } from '../types';

const DesktopNavigation = ({ handleGoToStep, hasStepZero = false }: StepHeaderNavigationProps) => (
  <InnerWrapper>
    <NavigationSteps hasStepZero={hasStepZero} handleGoToStep={handleGoToStep} />
  </InnerWrapper>
);

export default DesktopNavigation;
